<script>
export default {
    name: "switch-off-times-timepicker",
    props: {
        disabled: Boolean,
        value: String,
        id: {
            type: String,
            required: true
        },
        popupUsedInModal: Boolean,
    },
}
</script>

<template>
    <label aria-label="time">
        <timepicker
            :id="id"
            :value="value"
            @input="$emit('input', $event)"
            :disabled="disabled"
            hide-format-hint
            disable-prefix-icon
            :popup-used-in-modal="popupUsedInModal"
        />
    </label>
</template>

